export default __webpack_public_path__ + "static/media/distance.f9bb45f8.png";